/**
 * created by han guo qi
 * 快手发布视频上传封面图片
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Modal} from "antd";
import CmForm from "../../../../components/CmForm/CmForm";
import {Scrollbars} from "react-custom-scrollbars";
import UploadWall from "../../../../components/upload/UploadWall";
import {PIC_TYPE,PIC_TYPE_ORIGINAL} from "../../../../constants";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import {rmtMessage} from "../mess";

class UploadImage extends Component {
    constructor(props) {
        super(props);
        this.state={
            fileList: [],
        }
    }



    componentDidMount() {

    }
    onChange = (info) => {
        let fileList = info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if(info.file.response && info.file.response.data){
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.path = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        let newFileLis = [fileList.at(-1)];
        this.props.onChange(JSON.parse(JSON.stringify(newFileLis)));
        this.setState({fileList: newFileLis})
    };

    handleRemove =  file => {
        let fileList = this.state.fileList.filter(item => item.uid !== file.uid);
        this.setState({
            fileList
        });
    };


    handlePreview = file => {
        if(file && file.url){
            this.setState({
                previewImage: file.url,
                previewVisible: true,
            });
        }
    };
    render() {
        return (
            <div>
                <Scrollbars style={{height:343}}>
                    <div style={{padding:10}}>
                        {this.upload("")}
                    </div>
                </Scrollbars>
                <Modal
                    maskClosable={false}
                    keyboard={true}
                    zIndex={3000}
                    visible={this.state.previewVisible}
                    footer={null}
                    onCancel={() => this.setState({ previewVisible: false })}>
                    <CmForm onSubmit={() => {

                    }}>
                        <div style={{paddingTop:20}}>
                            {
                                <img style={{ width: '100%' }} src={this.state.previewImage} />
                            }
                        </div>
                    </CmForm>
                </Modal>
            </div>
        );
    }


    upload(listType) {
        const {fileList} = this.state;
        const accept = this.props.accept ||  "."+PIC_TYPE_ORIGINAL.join(",.")
        return (
            <UploadWall
                accept={accept}
                multiple={true}
                action="/storage/uploadFile"
                listType={listType}
                fileList={fileList}
                style={{padding:'unset'}}
                customRequest={new ChunkUpload({
                    checkFileURL:"/storage/checkFile",
                    checkChunkURL:"/storage/checkChunk",
                    uploadChunkURL:"/storage/uploadChunk",
                    chunkUploadOverURL:"/storage/chunkIsUploadOver",
                    mergeChunksURL:"/storage/mergeChunk"
                }).start}
                icons={["eye", "download", "delete"]}
                uploadBtnName={"点击上传"}
                beforeUpload={(file)=>{
                    if(this.props.beforeUpload) {
                        return this.props.beforeUpload(file)
                    } else if(this.beforeUpload) {
                        return this.beforeUpload(file)
                    }
                    return true
                }}
                onChange={this.onChange}
                onRemove={this.handleRemove}
                onPreview={this.handlePreview}
            />
        )
    }
}

UploadImage.propTypes = {};

export default UploadImage;